
import './App.css';


import { BrowserRouter, Routes, Route } from "react-router-dom";


import Login from './Components/Login/Login';
import Header2 from './Components/Login/Header2';
import UploadProcesados from './Components/FileUpload/UploadProcesados';
import UploadNew from './Components/FileUpload/UploadNew';
import ReviewTemporal from './Components/ReviewTemporal/ReviewTemporal';
import ReviewProduccion from './Components/ReviewTemporal/ReviewProduccion';
import Saldos from './Components/Saldos/Saldos';



function App() {
  return (
    <div className='layout-wrapper layout-static p-ripple-disabled' style={{backgroundColor : 'lightblue'}}>

    <BrowserRouter>

      {/*<Header></Header>*/}
      <Header2></Header2>

      <Routes>

        <Route path="/" element={<Login/>} />
        <Route path="/uploadprocesados" element={<UploadProcesados/>}/>
        <Route path="/uploadnew" element={<UploadNew/>}/>
        <Route path="/reviewtemporal" element={<ReviewTemporal/>} />
        <Route path="/reviewproduccion" element={<ReviewProduccion/>} />
        <Route path="/saldos" element={<Saldos/>} />

      </Routes>
    </BrowserRouter>

  </div>
 
   
  );
}

export default App;
